<template>
  <div class="kinship-wrapper">
    <div v-if="isShowTitle"
         class="mb20 fb">{{title}}</div>
    <avue-crud v-if="orderId"
               :data="data"
               :option="option"
               v-model="form"
               :table-loading="loading"
               ref="crud"
               @row-del="rowDel"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @on-load="onLoad"
               @error="error"
               :before-open="beforeOpen">
      <!-- <template slot="voucherUrlType" slot-scope="{file}">
                <span>{{file.url}}</span>
            </template> -->
      <template slot-scope="{row}"
                slot="voucherNo">
        <div class="num-family">{{row.voucherNo}}</div>
      </template>
    </avue-crud>
    <avue-crud :data="data"
               v-if="!orderId"
               :option="option"
               v-model="form"
               :table-loading="loading"
               :page.sync="page"
               ref="crud"
               @row-del="rowDel"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @on-load="onLoad"
               @error="error"
               :before-open="beforeOpen">
      <!-- <template slot="voucherUrlType" slot-scope="{file}">
                <span>{{file.url}}</span>
            </template> -->
      <template slot-scope="{row}"
                slot="voucherNo">
        <div class="num-family">{{row.voucherNo}}</div>
      </template>
    </avue-crud>
    <div class="mt10"
         <!-- v-if="tips">注：该凭证号条形码同时生成至上传的凭证文件上左上角；PDF417条形码在右上角。</div> -->
    <div class="tac mt15"
         slot>
      <el-button type="primary"
                 size="mini"
                 icon="el-icon-plus"
                 v-if="isShowBtn"
                 @click="$refs.crud.rowAdd()">{{addBtnTitle}}</el-button>
      <slot></slot>
    </div>
    <el-dialog append-to-body
               width="80%"
               :visible.sync="OnlinelVisible"
               custom-class="common-dialog">
      <pdfOnLine :src="pdfSrc"></pdfOnLine>
    </el-dialog>
  </div>
</template>
<script>
import { remove, update, add, getList } from "@/api/order/orderjudicial";
import { mapGetters } from "vuex";
import { cardid, isvalidatemobile } from '@/util/validate'
import { getAttachFile } from "@/api/resource/oss"
import pdfOnLine from '@/components/pdf-online/index.vue'
export default {
  props: {
    isShowTitle: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '公检司法相关凭证'
    },
    isShowBtn: {
      type: Boolean,
      default: true
    },
    addBtnTitle: {
      type: String,
      default: '添加凭证'
    },
    orderId: {
      type: String,
      default: ''
    },
    list: {
      type: Array
    },
    tips: {
      type: Boolean,
      default: false
    },
    isOpt: {
      type: Boolean,
      default: true
    },
    isSee: {
      type: Boolean,
      default: false
    }
  },
  components: {
    pdfOnLine
  },
  data () {
    var checkCardid = (rule, value, callback) => {
      let list = cardid(value);
      if (!value) {
        callback();
      } else {
        if (list[0]) {
          return callback(new Error(list[1]));
        } else {
          callback();
        }
      }

    };
    var checkPhone = (rule, value, callback) => {
      let list = isvalidatemobile(value);
      if (!value) {
        callback();
      } else {
        if (list[0]) {
          return callback(new Error(list[1]));
        } else {
          callback();
        }
      }

    };

    return {
      pdfSrc: '',
      OnlinelVisible: false,
      form: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      data: [],
      option: {
        size: 'mini',
        border: true,
        align: 'center',
        menuAlign: 'center',
        delBtn: this.isOpt,
        viewBtn: this.isSee,
        editBtn: this.isOpt,
        addBtn: false,
        cellBtn: false,
        columnBtn: false,
        refreshBtn: false,
        menuBtn: false,
        labelWidth: 120,
        menu: this.isOpt || this.isSee,
        column: [{
          display: false,
          label: '凭证编号',
          prop: 'voucherNo',
          row: true,
          span: 24,
          rules: [{
            required: true,
            message: "请输入凭证编号",
            trigger: "blur"
          }]
        },
        {
          label: '凭证名称',
          prop: 'voucherName',
          row: true,
          span: 24,
          rules: [{
            required: true,
            trigger: "blur",
            message: "请输入凭证名称",
          }]
        },
        {
          label: '颁发机构',
          prop: 'awardOrg',
          dataType: 'string',
          // type: 'select',
          // type: 'cascader',
          type: 'tree',
          multiple: true,
          checkStrictly: true,
          // emitPath: false,
          leafOnly: false,
          row: true,
          span: 24,
          // dicUrl: "/api/blade-order/order/getDeptList",
          dicUrl: "/api/blade-system/dept/tree",
          props: {
            // label: "deptName",
            // value: "id"
            label: 'title'
          },
          formatter: (row, value, label, column) => {
            return label
          },
          rules: [{
            required: true,
            message: "请输入颁发机构",
            trigger: "blur"
          }]
        },
        {
          label: '凭证类型',
          prop: 'type',
          type: "select",
          dicUrl: "/api/blade-system/dict-biz/dictionary",
          dicQuery: {
            code: 'document_type'
          },
          props: {
            label: "dictValue",
            value: "dictKey"
          },
          row: true,
          span: 24,
          rules: [{
            required: true,
            message: "请选择凭证类型",
            trigger: "blur"
          }]
        },
        {
          label: '颁发时间',
          prop: 'awardTime',
          row: true,
          type: 'date',
          valueFormat: "yyyy-MM-dd hh:mm:ss",
          span: 24,
          rules: [{
            required: true,
            message: "请选择时间",
            trigger: "change",
          }],
        },
        {
          label: "上传凭证文件",
          prop: "voucherUrl",
          type: 'upload',
          dataType: 'array',
          loadText: '文件上传中，请稍等',
          tip: '只能上传PDF版凭证颁发的依据文件，且不超过2MB',
          // action: '/api/blade-resource/oss/endpoint/put-file-attach-by-name-new',
          // propsHttp: {
          //     url: 'data'
          // },
          action: '/api/blade-resource/oss/endpoint/put-file',
          propsHttp: {
            res: 'data',
            url: 'link',
          },
          rules: [{
            required: true,
            message: "请上传凭证文件",
            trigger: "blur"
          }],
          data: {
            fileName: 'voucherUrl'
          },
          uploadBefore: (file, done, loading) => {
            var FileExt = file.name.replace(/.+\./, "");
            if (['pdf'].indexOf(FileExt.toLowerCase()) === -1) {
              this.$message({
                type: 'warning',
                message: '请上传后缀名为PDF的附件！'
              });
              loading();
            } else {
              this.isLt2k = file.size / (1024 * 1024) < 2;
              if (!this.isLt2k) {
                this.$message({
                  message: '上传文件大小不能超过2MB!',
                  type: 'error'
                });
                loading();
              } else {
                done()
              }
            }
          },
          uploadPreview: (file, column, done) => {
            this.pdfSrc = file.url
            this.OnlinelVisible = true
          },
          span: 24,
          hide: true
        },
        {
          label: '快递发送时间',
          prop: 'expressBeginTime',
          type: 'date',
          valueFormat: "yyyy-MM-dd hh:mm:ss",
          span: 24,
          hide: true
        },
        {
          label: '快递单号',
          prop: 'expressNo',
          span: 24,
          hide: true
        },
        {
          label: '代理人姓名',
          prop: 'agent',
          span: 24,
        },
        {
          label: '身份证',
          prop: 'cardId',
          span: 24,
          rules: [{
            trigger: "blur",
            validator: checkCardid
          }],
        },
        {
          label: '电话',
          prop: 'phone',
          span: 24,
          rules: [{
            trigger: "blur",
            validator: checkPhone
          }],
        },
        {
          label: "机构名称",
          prop: "createDept",
          type: 'cascader',
          // dataType: 'string',
          emitPath: false,
          checkStrictly: true,
          showAllLevels: false,
          // dicUrl: "/api/blade-order/order/getDeptList",
          dicUrl: "/api/blade-system/dept/tree",
          props: {
            // label: "deptName",
            label: 'title',
            value: "id"
          },
          // formatter: (row, value, label, column) => {
          //     return label
          // },
          row: true,
          span: 24
        },
        // {
        //     label: "日期/时间",
        //     prop: "date",
        //     row: true,
        //     type: 'date',
        //     valueFormat: "yyyy-MM-dd hh:mm:ss",
        //     span: 24,
        // },
        {
          label: "上传执行凭证",
          prop: "imgUrls",
          type: 'upload',
          dataType: 'array',
          listType: 'picture-card',
          loadText: '图片上传中，请稍等',
          tip: '只能上传jpg/png 凭证图片，且不超过2MB',
          action: '/api/blade-resource/oss/endpoint/put-file-attach',
          propsHttp: {
            res: 'data',
            url: 'link'
          },
          // canvasOption: {
          //     text: '公益项目信息化管理系统',
          //     ratio: 0.1
          // },
          data: {
            fileName: 'imgUrls'
          },
          span: 24,
          hide: true,
          uploadBefore: (file, done, loading) => {
            var FileExt = file.name.replace(/.+\./, "");
            if (['jpg', 'png', 'jpeg'].indexOf(FileExt.toLowerCase()) === -1) {
              this.$message({
                type: 'warning',
                message: '请上传后缀名为jpg/png的图片！'
              });
              loading();
            } else {
              this.isLt2k = file.size / (1024 * 1024) < 2;
              if (!this.isLt2k) {
                this.$message({
                  message: '上传图片大小不能超过2MB!',
                  type: 'error'
                });
                loading();
              } else {
                done()
              }
            }
          },
          // uploadBefore: () => {
          //     makeBucket("/images").then(res => {
          //         console.log(res)
          //     })
          // }
        },
        {
          label: '描述',
          labelPosition: 'top',
          prop: 'judicialDescribe',
          span: 24,
          type: "textarea",
          hide: true
        },
        {
          label: '具体描述',
          labelPosition: 'top',
          prop: 'remarks',
          span: 24,
          type: "textarea",
          hide: true
        },
        {
          label: '订单id',
          prop: 'orderId',
          display: false,
          hide: true,
          span: 24,
          disabled: true
        }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    orderId () {
      this.form.orderId = this.orderId
    },
    list: {
      deep: true,
      handler (val) {
        this.data = this.list
      }
    }
  },
  methods: {
    beforeOpen (done, type) {
      if (["add"].includes(type)) {
        this.form.createDept = this.userInfo.dept_id
        this.$nextTick(() => {
          done();
        })
      } else {
        done();
      }


    },
    rowSave (row, done, loading) {
      if (!this.orderId) {
        this.data.push(row)
        done();
        this.$emit('getList', this.data)
        return
      }
      row.orderId = this.orderId

      add(row).then(res => {
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        this.data.push(res.data.data)
        this.$emit('getList', this.data)
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowUpdate (row, index, done, loading) {
      if (!this.orderId) {
        this.$set(this.data, index, row)
        // [index] = row
        done();
        this.$emit('getList', this.data)
        return
      }
      update(row).then(() => {
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        this.$set(this.data, index, row)
        this.$emit('getList', this.data)
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowDel (row, index) {
      if (!this.orderId) {
        this.data.splice(index, 1)
        this.$emit('getList', this.data)
        return
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.data.splice(index, 1)
          this.$emit('getList', this.data)
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        });
    },
    onLoad (page, params = {}) {
      this.loading = true;
      if ((this.list && this.list.length > 0) || !this.form.orderId) {
        this.data = this.list || []
        this.page.total = this.data.length;
        this.loading = false;
        return
      }

    },
    error (err) {
      this.$message.success('请填写完整信息');
    }
  }
}

</script>
<style>
.kinship-wrapper .avue-crud__menu {
  display: none !important;
}
</style>
